module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_20",
      "title": "20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Colonna-MT"
  }, [_vm._v("PROLOGUE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Subtitle-cst"
  }, [_vm._v("TERRIBLE BEAUTIES ARE BORN")]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-non-verse-cepi"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Too long a sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-non-verse-cepi"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Can make a stone of the heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-Source-ceps"
  }, [_vm._v("—W. B. Yeats")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("All was quiet on New Year’s Day before dawn. Near Galway, below a thatched cottage like they kept for the tourists, the quiet old man called Oz came suddenly awake in his cave, as if the lack of noise had startled his sleep. He got up from his warm cavern bed and rubbed his gray stubble, cross with the world. He hadn’t had a foreboding since the peace in the North, except for the gentle one that came to all the old and told him that he must pass on his gifts soon, lest they be lost.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("No use complaining. In the dark, Oz put on his worn white Aran sweater and one of the fancy fiber macintoshes the young ones preferred. He slung his rifle over his shoulder and, every joint hurting, climbed up the ladder to his cottage home.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He stepped outside. Beyond his yard’s low wall of rounded stone, the ground was flat and exposed. There’d be no surprises today. He made a sign of the cross in the air, and walked toward the town. They’d be coming from there, rested and ready.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He walked stiffly, as if he’d ridden a horse for a few centuries like his ancestor of honored memory. He wouldn’t have to walk far. He whistled a traditional reel, then hummed something by the Pogues. A mist blew silently in from the west, chilling, but well above freezing. Good on you, Gulf Stream, but couldn’t you do better? But no, it "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_21",
      "title": "21"
    }
  }, [_vm._v("was warmer these days, and snow wasn’t as general over Ireland, thank ya, climate change. Let the Yank weathermen try playing against that for a while.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The foreboding that had woken him capped a week of his personal warning signs. A photographer with long hair and etched face, like David Warner in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Omen,")]), _vm._v(" boarding the ferry for Inis M"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ó")]), _vm._v("r. A pale young woman in colorless clothes, like one of the hard ones he’d known in the Provisionals, drinking steaming coffee out of doors in the gray weather. A dog growling at Oz’s shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("With the mundane peace, the signs he’d seen about town could only mean one thing. They were again coming for him, coming for his gifts. Not that he cared to keep such things, but they wouldn’t be coming for the right reasons. They were coming for the worst reasons in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The worst reason they’d want his gifts would be to open a way to hell. He knew that from another sign: a phantom pain from his index finger’s missing tip, which he’d lost poking like an eejit at a hellworld’s portal. Same as the ache in his joints foretold rain, that finger pain told him another portal would be opening soon, if it hadn’t already.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ahead, three faint shadows moved toward him from the glow of the town. Oz looked about him. This field, never plowed, was the place.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The three would be C"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ú")]), _vm._v("chulainns, Hounds of Ulster. Tough bastards, but some had anger management issues. He didn’t need to discern the blond hair of a deliberately bad dye job and the pair of eyes of different colors, one green, one gray, to know who their young leader was.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Fergus,” he called. “What business has you out on this fine morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Fergus raised a hand, and his two companions, a man and a woman, halted. “We’ll have them, Ossian MacCool. The flail and the sand and you. All the gifts.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ah, lad,” said Oz. “I can understand working for the Left Hand. But the Sasanach too?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_22",
      "title": "22"
    }
  }, [_vm._v("“Albion is divided,” said Fergus. “It’s an opportunity.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Albion can go feck itself by itself,” said Oz. “You brought three against one? You’re treating me like Roderick Morton.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The Hounds drew weapons and panned the countryside, looking for others. Damn his loquacious habits. Oz had gone too far, and the Hounds must have heard the deception. He whistled, and his own young (or at least younger) ones sprang up from their craft-camouflaged positions, a matching man and woman for Fergus’s, weapons at ready.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Fergus gave a grim chuckle. “We have a fair fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We have a standoff,” said Oz, waving his hand back toward Galway. “So stand off.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No,” said Fergus. “We have a duel.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Now that was a surprise. Oz considered. His commission was important—more important now than ever—but he was one of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("filí")]), _vm._v(" to the bone, and he could not decline another craft poet’s challenge even to keep the gifts safe. “Fair enough. A duel then.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Their companions drew back, lest some shrapnelled syllables hit them. A modern Irish duel of craft poets did not require original composition; it was improvisational pastiche, deadly riffs on the nation’s verse and song, which already had all the magical words one could desire. Each duelist would find the words that had both power and hard truths to sing against their opponent. After a few rounds of verses, the damage to body and spirit would tell, and one of the poets would fall. Any outside interference during the duel would draw the wrath of all the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("filí.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("With an indulgence ill-befitting the seriousness of the conflict, Oz nodded at Fergus to begin. The challenger would go first.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("In a quavering voice like the lead singer of the Undertones, Fergus sang:")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You are stretched in your grave")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You shall rot there forever")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_23",
      "title": "23"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You shall smell of the dirt")])])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You’ll be worn by the weather.")])]), _vm._v(" "), _c('p', {
    staticClass: "STXS"
  }, [_vm._v("The red craft of each word bit into Oz like bullets, and he saw himself crawling back to his cave, and the earth folding in on him, finally giving him peace. Fergus leered at him. Stupid boy—nobody won a major duel with one round of verse. Oz shook off the bits of death and launched his own words in return, matching the craft of his challenger in a fine Irish tenor, so unlike his old and gravelly speaking voice.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The night is long")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And no day shall come;")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I promise that")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You’re the dying one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Being what you are,")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You could never learn:")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Like another Troy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I shall make you burn.")])]), _vm._v(" "), _c('p', {
    staticClass: "STXS"
  }, [_vm._v("Fergus flinched away like a scalded cat from the fire in the words. But Fergus did not pause to collect himself, replying with an instant growl as if hoping to catch Oz off guard with haste and simple malice:")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You Left-Handed maggot")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You’re weak and you’re haggard")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("This Solstice past")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Shall be your last.")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("Oz’s nose began to bleed. The words had wounded because they were true. Like many others, Oz had pulled some Left-Handed tricks during the Troubles, and he felt sin on his soul that no confession could remove. This year was certainly his last on earth. But, perhaps because Oz accepted their truth, the words did not carry immediate death.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_24",
      "title": "24"
    }
  }, [_vm._v("Anyway, Oz could play on past sins as well as Fergus:")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Like all the tea in China, dog,")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The sins you cannot leave behind,")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They boil inside your mental fog,")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They tear in two your greedy mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "STXS"
  }, [_vm._v("Fergus’s hands went to his head, clutching it as if it buzzed with bees instead of crimes. But he recovered himself. “Still wide awake and sweet as honey,” he said, spitting blood onto the grass like a boxer. For this round, he gave himself more time, no doubt to think more carefully about his words. In their weakened state, they both knew that any verse now could be their last.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You change, change utterly:")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Your heart is turned to stone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Your center cannot hold:")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Slouch off to die alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("The bitter words burned like cold iron. They tore at Oz’s heart and drove him to his hands and knees. Just one more word, the right syllable, would have quartered him along mystic dotted lines. Like sharks smelling blood in the water, the other Hounds inched toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But Oz didn’t leave the living stream. Painfully, he rose up on his stiff knees. “My death is too soon for you to trouble me with it.” Time to give Fergus the bad news about their relative power; time to end this. But he would not take Fergus’s life, not today. One thing he’d learned from this exchange: he’d killed enough. He didn’t want more blood staining his karmic ledger now, and dead craftsmen aplenty would be coming soon.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("In the east, the sun was rising. With his best full-throated voice, Oz sang:")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_25",
      "title": "25"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Who will drive for Fergus now")])])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When all his light has gone to shade?")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Why lift his tender eyelids now")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Song-Lyric-extsl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When his bright eyes forever fade?")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("The words flew from Oz like knives into Fergus’s face. With audible pops, Fergus’s eyes burst from his sockets.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Fergus screamed like a snapper; his fingers went to his bleeding eye holes. “You bastard!” he howled. Fergus wouldn’t understand this grace—his whole generation refused to understand such cold grace. Cut off from sight and the active service of the Left Hand, Fergus might yet become the greatest of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("filí")]), _vm._v(" and another Turlough O’Carolan of craft song, while Oz would be moldering in the grave.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The other Hounds stared at Oz, hands ready to bring weapons to bear. Oz dismissed them with a wave of his arm. “Take him away before I give you the same.” With reluctant slowness, they led away their blind leader as he wept blood.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("One of Oz’s guards, a dead ringer for Maureen O’Hara at fifty except for the shorter hair and grimmer mouth, said, “They’ll be back with more.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So they will. Give them something to remember us, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("macushla")]), _vm._v(".” But Oz wouldn’t be here. He was packed and ready. He’d go to Shannon Airport and pass through the flow of returning dead from the diaspora and the ghost guards. And go on to where? He’d need more of one of the gifts, but he wouldn’t fly to Italy directly. First, he’d go on to somewhere they wouldn’t immediately follow; somewhere he could feel for the coming portal. Into the west? Maybe, but he wouldn’t think about it; he didn’t want any farsight tracking his movements until it was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Had the time truly come to use "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("all")]), _vm._v(" the gifts? Fergus and his friends seemed to think so, though their uses would be different from his. In the first light of dawn, Oz looked about at his country, and the dear sight of it brought him another foreboding, and a few tears. After today, he’d never see his home again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 78
// module chunks = 0